
import _ from 'lodash'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from 'swiper/modules';


const Agencyview = () => {
  const image = require("../../assets/img/image 1.png")




  const HomePageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_AGENCY_BANNER') : null;
  const banner: any = (HomePageBannerData && HomePageBannerData[0]?.src ? encodeURI(HomePageBannerData[0]?.src) : require('../../assets/img/ONESP.png'))
  const HomePageBannerContentData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_AGENCY_HOME_MAIN_BANNER_CONTENT') : null;

  const workProcessHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_AGENCY_HOME_PAGE_MAJOR_HIGHLIGHTS') : null;

  const workProcessData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_AGENCY_HOME_PAGE_MAJOR_HIGHLIGHTS_CONTENT') : null;

  const leftImageData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_AGENCY_HOME_PAGE_LEFT_IMAGE') : null;

  const agencyHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_AGENCY_HOME_MAIN_PAGE_AGENCY_HEADING') : null;
  const agencyData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_AGENCY_HOME_MAIN_PAGE_AGENCY') : null;

  const agencyFirstImage: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_AGENCY_HOME_MAIN_PAGE_FIRST_IMAGE') : null;
  const agencySecondImage: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_AGENCY_HOME_MAIN_PAGE_SECOND_IMAGE') : null;
  const agencyFirstHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_AGENCY_HOME_MAIN_PAGE_FIRST_HEADING') : null;
  const agencyFirstData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_AGENCY_MAIN_PAGE_FIRST_CONTENT') : null;
  const agencySecondtData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_AGENCY_MAIN_PAGE_SECOND_CONTENT') : null;



console.log('HomePageBannerData',HomePageBannerData)
console.log('banner',banner)

  const dummyData = [{

    src: "../../assets/img/image 1.png",
    title: "name",
    subTitle: "proffesion",
  },
  {
    src: "../../assets/img/image 1.png",
    title: "name",
    subTitle: "proffesion",
  }, {
    src: "../../assets/img/image 1.png",
    title: "name",
    subTitle: "proffesion",
  }, {
    src: "../../assets/img/image 1.png",
    title: "name",
    subTitle: "proffesion",
  }, {
    src: "../../assets/img/image 1.png",
    title: "name",
    subTitle: "proffesion",
  }]
  return (
    <>

      <div className={`flex flex-col items-center justify-center w-full  `} >


        {/* Banner Section */}
        <div className="flex flex-col items-center justify-center w-full" style={{ backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
          <div className="flex justify-end items-center p-1 w-full h-[650px] px-10">
            <div className="mr-[100]]">
              <div className="bg-primary text-white rounded-2xl shadow-2xl p-8 max-w-lg transition-all duration-300 hover:shadow-[0_20px_50px_rgba(8,112,184,0.2)] hover:scale-105">
                <h1 className="text-4xl font-extrabold tracking-wide text-light mb-4">
                  {HomePageBannerContentData && HomePageBannerContentData[0]?.title
                    ? HomePageBannerContentData[0].title
                    : "ONESP"}
                </h1>

                <h2 className="text-xl font-semibold tracking-wider text-white mb-2">
                  {HomePageBannerContentData && HomePageBannerContentData[0]?.subTitle
                    ? HomePageBannerContentData[0].subTitle
                    : "Empowering Your Business with Technology"}
                </h2>

                <p className="text-base leading-relaxed font-light text-white">
                  {HomePageBannerContentData && HomePageBannerContentData[0]?.description
                    ? HomePageBannerContentData[0].description
                    : "SmartTech Solutions offers end-to-end digital services designed to help small and medium businesses grow online."}
                </p>
              </div>
            </div>
          </div>





        </div> <br></br>



        {/* Section 2 */}
        <div className="w-full flex items-center justify-center flex-col">
          <div className={`flex flex-col justify-center items-center w-full `}>
            <div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
              <div className="text-3xl font-bold ">
                {/* {workProcessHeading ? workProcessHeading[0]?.title : null} */}
                <h2></h2><br></br>

              </div>

            </div>
            <div className="w-full px-6 py-10 bg-white flex  flex-row items-start gap-10">

              {/* 🔹 Left Side Vertical Image - NARROW WIDTH */}
              <div className="w-1/4 flex justify-center">
                <img
                  src={
                    leftImageData && leftImageData[0]?.src
                      ? leftImageData[0].src
                      : image
                  }
                  alt="About ONESP"
                  className="rounded-lg shadow-lg object-cover h-[520px] w-auto"
                />

              </div>

              {/* 🔹 Right Side Content */}
              <div className="w-3/4 space-y-6">
                <div>
                  <h2 className="text-3xl font-bold">
                    {agencyHeading && agencyHeading[0]?.title ? (
                      (() => {
                        const titleWords = agencyHeading[0].title.split(' ');
                        const middle = Math.floor(titleWords.length / 2);
                        const firstHalf = titleWords.slice(0, middle).join(' ');
                        const secondHalf = titleWords.slice(middle).join(' ');
                        return (
                          <>
                            <span className="text-black">{firstHalf} </span>
                            <span className="text-primary">{secondHalf}</span>
                          </>
                        );
                      })()
                    ) : (
                      <>
                        <span className="text-orange-600">One Service Provider for </span>
                        <span className="text-black">Startups in India</span>
                      </>
                    )}
                  </h2>

                  {agencyHeading && agencyHeading[0]?.description ? (
                    <>
                      <p className="text-gray-700 mt-4">{agencyHeading[0].description}</p>
                    </>
                  ) : (
                    <>
                      <p className="text-gray-700 mt-4">SmartTech Solutions offers end-to-end digital services designed to help small and medium businesses grow online.
                      </p>

                    </>
                  )}

                </div>

                {/* 2x2 Info Cards */}
                <div className="grid grid-cols-2  gap-6">
                  {(agencyData && agencyData.length > 0 ? agencyData : Array(4).fill({})).map((item, index) => (
                    <div
                      key={index}
                      className="bg-gray-100 p-6 rounded-md shadow-sm h-[200px] w-full flex flex-col justify-between"
                    >
                      <h3 className="text-2xl font-bold text-primary">
                        {item?.title || 'Heading'}
                      </h3>
                      <p className="text-gray-600 mt-1 text-sm">
                        {item?.description || 'Description text goes here...'}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section: Excellence Center */}
        <div className="w-full bg-gray-100 px-6 py-16 mt-24">
          <div className="max-w-7xl mx-auto">
            {/* Section Heading */}
            <h2 className="text-3xl font-bold mb-10">
              {agencyFirstHeading && agencyFirstHeading[0]?.title ? (
                (() => {
                  const titleWords = agencyFirstHeading[0].title.split(' ');
                  const middle = Math.floor(titleWords.length / 2);
                  const firstHalf = titleWords.slice(0, middle).join(' ');
                  const secondHalf = titleWords.slice(middle).join(' ');
                  return (
                    <>
                      <span className="text-black">{firstHalf} </span>
                      <span className="text-primary">{secondHalf}</span>
                    </>
                  );
                })()
              ) : (
                <>
                  <span className="text-black">For Targeted impact– </span>
                  <span className="text-primary">Our excellence center</span>
                </>
              )}

            </h2>

            {/* Card Container */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Card 1 */}
              <div className="relative group">
                <img
                  src={agencyFirstImage && agencyFirstImage[0]?.src
                    ? agencyFirstImage[0].src
                    : image}
                  alt="Fintech"
                  className="rounded-md w-full h-80 object-cover"
                />
                {/* Arrow Box */}
                <div className="absolute top-0 right-0 bg-secondary p-2 text-white">
                  <span className="text-xl font-bold">→</span>
                </div>
                {/* Text Overlay */}
                <div className="absolute bottom-0 bg-secondary text-white p-2 h-36 w-full">
                  <h3 className="text-lg font-bold mb-2">
                    {agencyFirstData && agencyFirstData[0]?.title ? (
                      <span>{agencyFirstData[0].title}</span>
                    ) : (
                      <span>Who We Are?</span>
                    )}
                  </h3>

                  <p className="text-sm leading-relaxed">
                    {agencyFirstData && agencyFirstData[0]?.description
                      ? agencyFirstData[0].description
                      : "The traditional pipeline business transformed from the industrial era to the IT era in the late 1990s and the dot-com era in the early 2000s. Then, the aggregator business took off in the 2010s. It changed the digital era completely from the 2020s and will grow for decades"}
                  </p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="relative group">
                <img
                  src={agencySecondImage && agencySecondImage[0]?.src
                    ? agencySecondImage[0].src
                    : image}
                  alt="Climate"
                  className="rounded-md w-full h-80 object-cover"
                />
                {/* Arrow Box */}
                <div className="absolute top-0 right-0 bg-primary p-2 text-white">
                  <span className="text-xl font-bold">→</span>
                </div>
                {/* Text Overlay */}
                <div className="absolute bottom-0 bg-primary text-white p-2 h-36 w-full">
                  <h3 className="text-lg font-bold mb-2">
                    {agencySecondtData && agencySecondtData[0]?.title ? (
                      <span>{agencySecondtData[0].title}</span>
                    ) : (
                      <span>Who We Do?</span>
                    )}
                  </h3>

                  <p className="text-sm leading-relaxed">
                    {agencySecondtData && agencySecondtData[0]?.description
                      ? agencySecondtData[0].description
                      : "The traditional pipeline business transformed from the industrial era to the IT era in the late 1990s and the dot-com era in the early 2000s. Then, the aggregator business took off in the 2010s. It changed the digital era completely from the 2020s and will grow for decades"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section 4 */}
        <div className="bg-white px-6 py-10">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold mb-10 text-center">
              {workProcessHeading && workProcessHeading[0]?.title ? (
                (() => {
                  const titleWords = workProcessHeading[0].title.split(' ');
                  const middle = Math.floor(titleWords.length / 2);
                  const firstHalf = titleWords.slice(0, middle).join(' ');
                  const secondHalf = titleWords.slice(middle).join(' ');
                  return (
                    <>
                      <span className="text-black">{firstHalf} </span>
                      <span className="text-primary">{secondHalf}</span>
                    </>
                  );
                })()
              ) : (
                <>
                  <span className="text-black">The People </span>
                  <span className="text-primary">Behind the Vision</span>
                </>
              )}
            </h2>

            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={0}
              navigation
              autoplay={{ delay: 3000 }}
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 4 },
              }}
              className="w-full pt-10 bg-gray-100"
            >
              {(workProcessData?.length > 0 ? workProcessData : dummyData).map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="flex flex-col items-center p-4 ">

                    {/* Name */}
                    <div className="font-semibold text-lg text-center text-black">
                      {item?.title || 'Title'}
                    </div>

                    {/* Role */}
                    <div className="text-center text-gray-700 text-sm mb-2">
                      {item?.subTitle || 'Subtitle'}
                    </div>

                    {/* Image container with angled overlay */}
                    <div className="relative w-60 h-60 overflow-hidden">
                      <img
                        src={item?.src || 'https://via.placeholder.com/272x256'}
                        alt="card-image"
                        className="object-cover w-full h-full"
                      />
                      <div className="absolute bottom-0 left-0 w-full h-10 bg-secondary -skew-y-6 origin-bottom"></div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

          </div>
        </div>
      </div >
    </>
  )
}

export default Agencyview
